import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import Popup from "reactjs-popup";
import axios from "axios";
import LazyLoad from "react-lazyload";

import {
  getImgUrl,
  getUrl,
  compareDates,
  getWeather,
  asyncgetWeather,
  limitText,
  geinstagramData,
  isMobile,
} from "../../Utility/Utility";

import {
  TopPart,
  Img,
  HomeTitle,
  WeatherIcon,
  ResponsiveYouTubeIframe,
  VideoSliderItem,
  ConcertSliderItem,
  PostSliderItem,
  InstagremSliderItem,
  FaqItem,
  ImgAndText,
  HomeSlider,
  ActivaImg,
  AnimateCallToAction,
  VideoSliderItem2,
  TravelAlert,
} from "../../Components/UI/UI";

import { DealItem } from "../../Components/Deals/DealItem";

import {
  newPosts,
  showsArr,
  Reminders,
  faqData,
  newVideos,
} from "../../Data/Data";

// import AgreeCookies from '../../Components/AgreeCookies/AgreeCookies'

import Menu from "../../Components/Menu/Menu";
import Footer from "../../Components/Footer/Footer";
import SimpleSlider from "../../Components/SimpleSlider/SimpleSlider";

import "./Home.css";

// private class data

const galleryObj1 = {
  img: "Home/7.jpg",
  link: "/Pages/Gallery/ta",
  text: "تل-أبيب يافا",
};

const galleryObj2 = {
  img: "Home/8.jpg",
  link: "/Pages/Gallery/ja",
  text: "القدس",
};

const galleryObj3 = {
  img: "Home/9.jpg",
  link: "/Pages/Gallery/deadsea",
  text: "البحر الميت",
};

const galleryObj4 = {
  img: "Home/10.jpg",
  link: "/Pages/Gallery/yp",
  text: "الصور التي قمتم",
};

function Shuffle(o) {
  for (
    var j, x, i = o.length;
    i;
    j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x
  );
  return o;
}

const getParam = window.location.search;
console.log(typeof getParam);
console.log(getParam);

class Home extends Component {
  constructor(props) {
    super(props);
    this.playVideo = this.playVideo.bind(this);
    this.playVideo2 = this.playVideo2.bind(this);
    this.playVideo3 = this.playVideo3.bind(this);
    this.playVideo4 = this.playVideo4.bind(this);
    this.state = {
      isVidClick: false,
      instagramData: [],
      instagramDataMobile: [],
      northArrMobile: [],
      // isLoading : true;
      // exporeTelAvivAndjerusalemMainVid: "5nqL-oIC0GA", old video
      // exporeTelAvivAndjerusalemMainVid: "nLKWDp5uA-U", changed at 17.05.2020
      exporeTelAvivAndjerusalemMainVid: "FYtk8JMMZRE",
      eurovisionMainVid: "5PAjhoH0NWU",
      TelAvivAndjerusalemVideoState: 0,
      culinaryVid: "jfyHxk8ZRrI",
      culinaryVidState: 0,
      faq: faqData,
      telAvivWeather: 20,
      waterTemp: 20,
      jerusalemWeather: 20,
      deadSeaWeather: 15,
      shirCssClass: " btn-shir",
      supportCssClass: " new-support-btn",
      open: false,
      instagramId: null,
      instagramUserImg: null,
      instagramCaption: null,
      instagramUserName: null,
      instagramLikes: null,
      imageState: true,
      imageState2: true,
      imageState3: true,
      imageState4: true,
      imageState5: true,
      imageState6: true,
      imageState7: true,
      imageState8: true,
      imageState9: true,
      imageState10: true,
      width: 0,
      MobileVidId1: "",
      MobileVidId1Elm: "",

      MobileVidId2: "",
      MobileVidId2Elm: "",

      MobileVidId3: "",
      MobileVidId3Elm: "",
      isInit: true,
      text1:
        "تحذيرات السفر: القوا النظر على أحدث تحذيرات السفر التي من شأنها أن تكون ذا ت علاقة",
      text2: " باسرائيل",
      text3: "",
      coronaVirus:
        "https://corona.health.gov.il/ar/abroad/arriving-foreign-nationals/",
    };
  }

  componentWillMount() {
    this.updateDimensions();
  }
  updateDimensions = () => {
    var w = window,
      d = document,
      documentElement = d.documentElement,
      body = d.getElementsByTagName("body")[0],
      width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
    // height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;

    this.setState({ width: width });

    // Change the text of Alert message at Home page
    if (getParam === "?lang=uk") {
      this.setState({
        text1: "Travel Alert: Get the latest travel alerts impacting Israel",
        text2: " here",
        text3: "",
        coronaVirus: "/Pages/CoronaVirusPage",
      });
    } else if (getParam == "?lang=cz") {
      this.setState({
        text1:
          "Cestovatelská upozornění: Přečtěte si nejnovější upozornění týkající se cest do Izraele",
        text2: " zde",
        text3: "",
        coronaVirus: "/Pages/CoronaVirusPageCZ",
      });
    } else if (getParam === "?lang=ro") {
      this.setState({
        text1:
          "Alertă de călătorie: află ultimele informații privind alertele de călătorie din Israel",
        text2: " de aici",
        text3: "",
        coronaVirus: "/Pages/CoronaVirusPageRO",
      });
    } else if (getParam === "?lang=dk") {
      this.setState({
        text1:
          "Rejsevarsel: Få de senaste rejsevarsel med betydning for Israel",
        text2: " her",
        text3: "",
        coronaVirus: "/Pages/CoronaVirusPageDK",
      });
    } else if (getParam === "?lang=se") {
      this.setState({
        text1:
          "Reserekommendation: Få de senaste reserekommendationerna gällande Israel",
        text2: " här",
        text3: "",
        coronaVirus: "/Pages/CoronaVirusPageSE",
      });
    } else if (getParam === "?lang=hu") {
      this.setState({
        text1: "Utazási Riasztás:",
        text2: " Itt",
        text3: " érheti el az összes Izraelt érintő utazási riasztást",
        coronaVirus: "/Pages/CoronaVirusPage",
      });
    } else if (getParam === "?lang=nl") {
      this.setState({
        text1: "Reisadvies: ontvang",
        text2: " hier",
        text3: " de laatste reisadviezen die van invloed zijn op Israël",
        coronaVirus: "/Pages/CoronaVirusPageNL",
      });
    } else if (getParam === "?lang=gb") {
      this.setState({
        text1: "Travel Alert: Get the latest travel alerts impacting Israel",
        text2: " here",
        text3: "",
        coronaVirus: "/Pages/CoronaVirusPage",
      });
    }

    // if(getParam === '?lang=dk') {

    //   this.setState({
    //     text1: 'Rejsevarsel: Få de senaste rejsevarsel med betydning for Israel',
    //     text2: ' her',
    //     text3: '',
    //     coronaVirus: '/Pages/CoronaVirusPageDK'
    //   })

    // }
    // else if(getParam === '?lang=se') {

    //  this.setState({
    //     text1: 'Reserekommendation: Få de senaste reserekommendationerna gällande Israel',
    //     text2: ' här',
    //     text3: '',
    //     coronaVirus: '/Pages/CoronaVirusPageSE'
    //   })

    // }
  };
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.updateDimensions);
  }

  componentDidMount() {
    Promise.all([asyncgetWeather(), geinstagramData()]).then((response) => {
        var weather = response[0];
        const instagramData = response[1];

    
        // console.log(typeof weather);
        // console.log( weather);

        const jerusalemTemperature = '20';
        const deadSeaTemperature = '20';
        const telAvivTemperature = '20';
        const telAvivWaterTemp = '20';

        if (typeof weather !== 'object') {
            // console.log('The weather variable is a string.');
            
            // Find the starting index of the JSON object
            const jsonStartIndex = weather.indexOf('{"jerusalem"');
    
            if (jsonStartIndex !== -1) {
                  // Extract the JSON substring
                  const jsonString = weather.substring(jsonStartIndex);
      
                  // Log the extracted JSON string to verify
                  // console.log('Extracted JSON String:', jsonString);
      
                  try {
                      const weatherData = JSON.parse(jsonString);
                      // console.log('Parsed Weather Data:', weatherData);
      
                      // Accessing the required temperature values
                      const jerusalemTemperature = weatherData.jerusalem.temperature;
                      const deadSeaTemperature = weatherData.deadsea.temperature;
                      const telAvivTemperature = weatherData.telaviv.temperature;
                      const telAvivWaterTemp = weatherData.telaviv.water_temp;
      
                      // console.log('Jerusalem Temperature:', jerusalemTemperature);
                      // console.log('Dead Sea Temperature:', deadSeaTemperature);
                      // console.log('Tel Aviv Temperature:', telAvivTemperature);
                      // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
      
                      // Set the state with the extracted values
                      this.setState({
                          instagramData: instagramData.posts,
                          jerusalemWeather: jerusalemTemperature,
                          deadSeaWeather: deadSeaTemperature,
                          telAvivWeather: telAvivTemperature,
                          waterTemp: telAvivWaterTemp,
                      });
      
                  } catch (error) {
                      console.error('Error parsing JSON:', error);
                  }
              } else {
                  console.error('No JSON found in the weather response');
                  this.setState({
                    instagramData: instagramData.posts,
                    jerusalemWeather: jerusalemTemperature,
                    deadSeaWeather: deadSeaTemperature,
                    telAvivWeather: telAvivTemperature,
                    waterTemp: telAvivWaterTemp,
                });
              }
        } else {
            // console.log('The weather variable is an object.');
            this.setState({
                instagramData: instagramData.posts,
                jerusalemWeather: weather.jerusalem.temperature,
                deadSeaWeather: weather.deadsea.temperature,
                telAvivWeather: weather.telaviv.temperature,
                waterTemp: weather.jerusalem.water_temp,
            });
        }

    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
}

  openModal = (id) => {
    var url = getUrl() + "instagram-api.php?ID=" + id;

    // var url = 'https://www.instagram.com/p/'+id+'/?tagged=takeme2telaviv&__a=1';
    axios.get(url, {}).then((res) => {
      var obj = res.data;

      var userinfo = obj.graphql.shortcode_media;
      var likes = userinfo.edge_media_preview_like.count;
      var username = userinfo.owner.username;
      var caption = userinfo.edge_media_to_caption.edges[0].node.text;
      var userProfileImg = userinfo.owner.profile_pic_url;

      // console.log(username);

      this.setState({
        open: true,
        instagramId: id,
        instagramUserImg: userProfileImg,
        instagramCaption: caption,
        instagramUserName: username,
        instagramLikes: likes,
      });
    });
  };
  closeModal = () => {
    this.setState({ open: false });
  };

  handleScroll = (event) => {
    let y = window.scrollY,
      shirCssClass = "",
      supportCssClass;
    if (y > 300) {
      shirCssClass = " btn-shir show-from-left";
      supportCssClass = " new-support-btn show-from-right";
    } else {
      shirCssClass = " btn-shir";
      supportCssClass = " new-support-btn";
    }
    this.setState({
      shirCssClass: shirCssClass,
      supportCssClass: supportCssClass,
    });
  };

  //This was added for mobile youtube butn play
  playVideo = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState: false,
    });
  };
  playVideo2 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState2: false,
    });
  };
  playVideo3 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState3: false,
    });
  };
  playVideo4 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState4: false,
    });
  };
  playVideo5 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState5: false,
    });
  };
  playVideo6 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState6: false,
    });
  };
  playVideo7 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState7: false,
    });
  };

  playVideo8 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState8: false,
    });
  };

  playVideo9 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState9: false,
    });
  };

  playVideo10 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState10: false,
    });
  };

  closeAlert = (event) => {
    document.getElementById("travel-alert").style.display = "none";
  };
  setVideoMobile = (vidId, id) => {
    // alert('setVideoMobile : ' +   vidId);
    this.setState({ MobileVidId1: vidId, MobileVidId1Elm: id });
  };

  setVideoMobile2 = (vidId, id) => {
    // alert('setVideoMobile : ' +   vidId);
    this.setState({ MobileVidId2: vidId, MobileVidId2Elm: id });
  };

  setVideoMobile3 = (vidId, id) => {
    // alert('setVideoMobile : ' +   vidId);
    this.setState({ MobileVidId3: vidId, MobileVidId3Elm: id });
  };

  setVideo = (vidId, ctg) => {
    // alert("ss");
    if (
      ctg === "culinary" ||
      ctg === "culinarytelaviv" ||
      ctg === "culinaryjerusalem" ||
      ctg === "culinarynorth"
    ) {
      this.setState({ culinaryVid: vidId });
      const e = document.getElementById("CULINARY");

      scroll.scrollTo(e.offsetTop - 100);

      if (isMobile) {
        this.setState({
          imageState7: false,
        });
      }
    } else {
      const elm = document.getElementById("expore-tel-aviv-and-jerusalem");

      scroll.scrollTo(elm.offsetTop - 100);
      this.setState({ exporeTelAvivAndjerusalemMainVid: vidId });

      if (isMobile) {
        this.setState({
          imageState8: false,
        });
      }
    }
  };

  setCurrentFaq = (id) => {
    const faq = [...this.state.faq];
    const current = faq.find((o) => {
      return o.id === id;
    });
    if (current.isOpen === true) {
      current.isOpen = false;
    } else {
      current.isOpen = true;
    }
    this.setState({
      faq: faq,
    });
  };

  handleisVidClick = () => {
    this.setState({
      isVidClick: !this.state.isVidClick,
    });
  };

  render() {
    const remindersHtml = Reminders.map((o, i) => {
      let cssClass = "";
      if (o.hasOwnProperty("cssClass")) {
        cssClass = o.cssClass;
      }

      let job = "";
      if (o.hasOwnProperty("job")) {
        job = o.job;
      }
      return (
        <DealItem
          brand={o.site}
          isReminder={true}
          price={"“" + o.quote + "”"}
          desc={""}
          brandImg={o.img}
          cssClass={cssClass}
          ctg={o.ctg}
          job={o.job}
          callToActionText={"READ MORE"}
        />
      );
    });

    const sliderSettings = {
      dots: false,

      autoplay: true,
      // lazyLoad: 'ondemand',
      infinite: true,
      lazyLoad: "ondemand",
      cssEase: "linear",
      slidesToShow: this.props.items != undefined ? this.props.items : 3,
      slidesToScroll: 3,

      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    const sliderSettings2 = {
      dots: false,
      autoplay: true,
      // lazyLoad: 'ondemand',
      infinite: true,
      lazyLoad: "ondemand",
      cssEase: "linear",
      slidesToShow: this.props.items != undefined ? this.props.items : 3,
      slidesToScroll: 3,

      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    const culinaryArr = [];
    const postsArr = [];
    let videoArr = [];
    const eurovisionArr = [];
    const eilatNegevArr = [];
    const jerusalemArr = [];
    const telavivArr = [];
    const northArr = [];
    const deadseaArr = [];

    newPosts.map((o) => {
      // console.log('o' , o);

      if (
        o.ctg === "culinary" ||
        o.ctg === "culinarytelaviv" ||
        o.ctg === "culinaryjerusalem" ||
        o.ctg === "culinarynorth"
      ) {
        culinaryArr.push(o);
      } else if (o.ctg === "eurovision") {
        eurovisionArr.push(o);
      } else if (o.ctg === "eilat-negev") {
        eilatNegevArr.push(o);
      } else if (o.ctg === "north") {
        northArr.push(o);
      } else if (o.ctg === "jerusalem") {
        jerusalemArr.push(o);
      } else if (o.ctg === "telaviv") {
        telavivArr.push(o);
      } else if (o.ctg === "deadsea") {
        deadseaArr.push(o);
      } else {
        postsArr.push(o);
      }
    });

    console.log("newVideos:", newVideos);

    newVideos.map((o) => {
      // console.log('o' , o);

      if (o.isVid === true || o.forVidPage === true) {
        videoArr.push(o);
      }
    });

    // videoArr = Shuffle(videoArr);

    // console.log('Shuffle vid' , videoArr);

    const videoMobileArr = [];
    if (videoArr.length > 0) {
      var size = 1;

      if (this.state.width < 1000) {
        size = 2;
      }

      if (this.state.width < 600) {
        size = 4;
      }
      while (videoArr.length) {
        // console.log( 'easd' ,  postsArr.splice(0,4) );

        videoMobileArr.push(videoArr.splice(0, size));
      }
    }

    let videosHtml = null;
    if (videoMobileArr.length > 0) {
      videosHtml = videoMobileArr.map((arr, i) => {
        return arr.map((o, i) => {
          var title = o.title;
          // const url = getUrl() + "Posts/" + o.ctg  + '/' + o.id;
          const url = "Posts/" + o.ctg + "/" + o.id;

          return (
            <VideoSliderItem
              key={i}
              title={o.title}
              desc={o.desc}
              img={o.img}
              link={url}
              doBlank={false}
              mobileId={""}
              click={() => {
                this.setVideo(o.vidId, o.ctg);
              }}
            />
          );
        });
      });

      videosHtml = videosHtml.map((o, i) => {
        // console.log(o);
        return <div>{o}</div>;
      });
    }

    const postsHtml = postsArr.map((o, i) => {
      // const url = "/Posts/" + o.id ;
      const url = "/Posts/" + o.ctg + "/" + o.id;

      if (o.hasOwnProperty("showOnHome") && o.showOnHome === false) {
      } else {
        return (
          <PostSliderItem
            key={i}
            title={o.title}
            desc={o.sml_desc}
            doBlank={false}
            img={o.img}
            link={url}
          />
        );
      }
    });

    const deadseamObileArr = [];
    if (deadseaArr.length > 0) {
      var size = 1;

      if (this.state.width < 1000) {
        size = 2;
      }

      if (this.state.width < 600) {
        size = 4;
      }
      while (deadseaArr.length) {
        // console.log( 'easd' ,  deadseaArr.splice(0,4) );
        deadseamObileArr.push(deadseaArr.splice(0, size));
      }
    }

    let deadseaPostsHtml = null;
    if (deadseamObileArr.length > 0) {
      deadseaPostsHtml = deadseamObileArr.map((arr, i) => {
        return arr.map((o, i) => {
          var title = o.title;
          const url = "Posts/" + o.ctg + "/" + o.id;

          // if ( this.state.width < 1000 ){
          //     title = o.title + ' >';
          // }
          return (
            <PostSliderItem
              key={i}
              title={title}
              desc={o.sml_desc}
              doBlank={false}
              img={o.img}
              link={url}
            />
          );
        });
      });

      deadseaPostsHtml = deadseaPostsHtml.map((o, i) => {
        // console.log(o);
        return <div>{o}</div>;
      });
    }

    const eilatNegevmObileArr = [];
    if (eilatNegevArr.length > 0) {
      var size = 1;

      if (this.state.width < 1000) {
        size = 2;
      }

      if (this.state.width < 600) {
        size = 4;
      }
      while (eilatNegevArr.length) {
        // console.log( 'easd' ,  eilatNegevArr.splice(0,4) );
        eilatNegevmObileArr.push(eilatNegevArr.splice(0, size));
      }
    }

    let eilatNegevPostsHtml = null;
    if (eilatNegevmObileArr.length > 0) {
      eilatNegevPostsHtml = eilatNegevmObileArr.map((arr, i) => {
        return arr.map((o, i) => {
          var title = o.title;
          const url = "Posts/" + o.ctg + "/" + o.id;

          // if ( this.state.width < 1000 ){
          //     title = o.title + ' >';
          // }
          return (
            <PostSliderItem
              key={i}
              title={title}
              desc={o.sml_desc}
              doBlank={false}
              img={o.img}
              link={url}
            />
          );
        });
      });

      eilatNegevPostsHtml = eilatNegevPostsHtml.map((o, i) => {
        // console.log(o);
        return <div>{o}</div>;
      });
    }

    const jerusalemmObileArr = [];
    if (jerusalemArr.length > 0) {
      var size = 1;

      if (this.state.width < 1000) {
        size = 2;
      }

      if (this.state.width < 600) {
        size = 4;
      }
      while (jerusalemArr.length) {
        // console.log( 'easd' ,  jerusalemArr.splice(0,4) );
        jerusalemmObileArr.push(jerusalemArr.splice(0, size));
      }
    }

    let jerusalemPostsHtml = null;
    if (jerusalemmObileArr.length > 0) {
      jerusalemPostsHtml = jerusalemmObileArr.map((arr, i) => {
        return arr.map((o, i) => {
          var title = o.title;
          const url = "Posts/" + o.ctg + "/" + o.id;

          // if ( this.state.width < 1000 ){
          //     title = o.title + ' >';
          // }
          return (
            <PostSliderItem
              key={i}
              title={title}
              desc={o.sml_desc}
              doBlank={false}
              img={o.img}
              link={url}
            />
          );
        });
      });

      jerusalemPostsHtml = jerusalemPostsHtml.map((o, i) => {
        // console.log(o);
        return <div>{o}</div>;
      });
    }

    const telavivmObileArr = [];
    if (telavivArr.length > 0) {
      var size = 1;

      if (this.state.width < 1000) {
        size = 2;
      }

      if (this.state.width < 600) {
        size = 4;
      }
      while (telavivArr.length) {
        // console.log( 'easd' ,  telavivArr.splice(0,4) );
        telavivmObileArr.push(telavivArr.splice(0, size));
      }
    }

    let telavivPostsHtml = null;
    if (telavivmObileArr.length > 0) {
      telavivPostsHtml = telavivmObileArr.map((arr, i) => {
        return arr.map((o, i) => {
          var title = o.title;
          const url = "Posts/" + o.ctg + "/" + o.id;

          // if ( this.state.width < 1000 ){
          //     title = o.title + ' >';
          // }
          return (
            <PostSliderItem
              key={i}
              title={title}
              desc={o.sml_desc}
              doBlank={false}
              img={o.img}
              link={url}
            />
          );
        });
      });

      telavivPostsHtml = telavivPostsHtml.map((o, i) => {
        // console.log(o);
        return <div>{o}</div>;
      });
    }

    const northmObileArr = [];
    if (northArr.length > 0) {
      var size = 1;

      if (this.state.width < 1000) {
        size = 2;
      }

      if (this.state.width < 600) {
        size = 4;
      }
      while (northArr.length) {
        // console.log( 'easd' ,  northArr.splice(0,4) );
        northmObileArr.push(northArr.splice(0, size));
      }
    }

    let northPostsHtml = null;
    if (northmObileArr.length > 0) {
      northPostsHtml = northmObileArr.map((arr, i) => {
        return arr.map((o, i) => {
          var title = o.title;
          const url = "Posts/" + o.ctg + "/" + o.id;

          // if ( this.state.width < 1000 ){
          //     title = o.title + ' >';
          // }

          return (
            <PostSliderItem
              key={i}
              title={title}
              desc={o.sml_desc}
              doBlank={false}
              img={o.img}
              link={url}
            />
          );
        });
      });

      northPostsHtml = northPostsHtml.map((o, i) => {
        // console.log(o);
        return <div>{o}</div>;
      });
    }

    const culinaryMobileArr = [];
    if (culinaryArr.length > 0) {
      var size = 1;

      if (this.state.width < 1000) {
        size = 2;
      }

      if (this.state.width < 600) {
        size = 4;
      }
      while (culinaryArr.length) {
        // console.log( 'easd' ,  culinaryArr.splice(0,4) );
        culinaryMobileArr.push(culinaryArr.splice(0, size));
      }
    }

    let culinaryHtml = null;
    if (culinaryMobileArr.length > 0) {
      culinaryHtml = culinaryMobileArr.map((arr, i) => {
        return arr.map((o, i) => {
          var title = o.title;
          const url = "Posts/" + o.ctg + "/" + o.id;

          // if ( this.state.width < 1000 ){
          //     title = o.title + ' >';
          // }
          return (
            <VideoSliderItem
              key={i}
              title={o.title}
              desc={o.desc}
              img={o.img}
              link={url}
              doBlank={false}
              mobileId={""}
              click={() => {
                this.setVideo(o.vidId, o.ctg);
              }}
            />
          );
        });
      });

      culinaryHtml = culinaryHtml.map((o, i) => {
        // console.log(o);
        return <div>{o}</div>;
      });
    }

    const eurovisionHtml = eurovisionArr.map((o, i) => {
      // const url = "/Posts/" + o.id ;
      const url = "/Posts/" + o.ctg + "/" + o.id;

      if (o.hasOwnProperty("showOnHome") && o.showOnHome === false) {
      } else {
        return (
          <PostSliderItem
            key={i}
            title={o.title}
            desc={o.sml_desc}
            doBlank={false}
            img={o.img}
            link={url}
          />
        );
      }
    });

    var date1 = new Date();
    let hasBean = [];
    let notHasBean = [];

    showsArr.map((o, i) => {
      const isTodayBigger = compareDates(date1, o.date);
      if (
        isTodayBigger === true ||
        o.date === "30.12.2017" ||
        o.date === "21.06.2018"
      ) {
        // o.cssClass +=" addOpacity ";
        // hasBean.push(o);
      } else {
        o.cssClass = "";
        notHasBean.push(o);
      }
    });

    // marge two array into array
    let newshowsArr = [...notHasBean, ...hasBean];
    const concertsmObileArr = [];
    if (newshowsArr.length > 0) {
      var size = 1;

      if (this.state.width < 1000) {
        size = 2;
      }

      if (this.state.width < 600) {
        size = 4;
      }
      while (newshowsArr.length) {
        // console.log( 'easd' ,  newshowsArr.splice(0,4) );
        concertsmObileArr.push(newshowsArr.splice(0, size));
      }
    }

    let concertSHtml = null;
    if (concertsmObileArr.length > 0) {
      concertSHtml = concertsmObileArr.map((arr, i) => {
        return arr.map((o, i) => {
          var title = o.title;

          if (this.state.width < 1000) {
            title = o.title;
          }

          const url = "Posts/Concerts/" + o.id;
          return (
            <PostSliderItem
              key={i}
              title={title}
              desc={o.sml_desc}
              doBlank={false}
              img={o.img}
              link={url}
            />
          );
        });
      });

      concertSHtml = concertSHtml.map((o, i) => {
        // console.log(o);
        return <div>{o}</div>;
      });
    }

    const faqHtml = this.state.faq.map((o) => {
      return (
        <FaqItem
          q={o.q}
          answer={o.answer}
          isOpen={o.isOpen}
          click={() => {
            this.setCurrentFaq(o.id);
          }}
        />
      );
    });
    let instagramHtml = null;

    let img1Url = "Home/Mobile/1.jpg";
    let img2Url = "Home/Mobile/2.jpg";
    let img3Url = "Home/Mobile/3.jpg";
    let img4Url = "Home/Mobile/4.jpg";
    let callToActionHtml = "";
    let twoCitesOneBreakVid = "";
    let euroVisionVid = "";
    let culinaryVid = "";
    let galleryHTML = (
      <SimpleSlider settings={sliderSettings}>
        <ImgAndText
          img={galleryObj1.img}
          cssClass={"col-100"}
          link={galleryObj1.link}
          text={galleryObj1.text}
        />
        <ImgAndText
          img={galleryObj3.img}
          cssClass={"col-100"}
          link={galleryObj3.link}
          text={galleryObj3.text}
        />
        <ImgAndText
          img={galleryObj2.img}
          cssClass={"col-100"}
          link={galleryObj2.link}
          text={galleryObj2.text}
        />
        <ImgAndText
          img={galleryObj4.img}
          cssClass={"col-100"}
          link={galleryObj4.link}
          text={galleryObj4.text}
        />
      </SimpleSlider>
    );

    if (this.state.width > 1000) {
      callToActionHtml = (
        <div>
          {/*<AnimateCallToAction
            src={"btn_shir.png"}
            cssClass={this.state.shirCssClass}
            link={"/international/Pages/bestDeals"}
          />*/}
          <AnimateCallToAction
            src={"touristinfo.svg"}
            cssClass={this.state.supportCssClass}
            link={"https://www.gov.il/en/service/virtual_office/"}
          />
        </div>
      );
      img1Url = "Home/1.jpg";
      img2Url = "Home/2.jpg";
      img3Url = "Home/3.jpg";
      img4Url = "Home/4.jpg";

      {
        /*euroVisionVid = <div className="hide-on-mobile">
                <ResponsiveYouTubeIframe vidId={this.state.eurovisionMainVid}  />
              </div>*/
      }
      {
        /*twoCitesOneBreakVid = <div className="hide-on-mobile">
                <ResponsiveYouTubeIframe vidId={this.state.exporeTelAvivAndjerusalemMainVid}  />
              </div>*/
      }
      {
        /*culinaryVid = <div className="hide-on-mobile">
        <ResponsiveYouTubeIframe vidId={this.state.culinaryVid} />
      </div>
      galleryHTML = <div className="row more-info-row">
                      <ImgAndText img={galleryObj1.img} cssClass={" col-33"} link={galleryObj1.link} text={galleryObj1.text} />
                      <ImgAndText img={galleryObj2.img} cssClass={" col-33"} link={galleryObj2.link} text={galleryObj2.text} />
                      <ImgAndText img={galleryObj3.img} cssClass={" col-33"} link={galleryObj3.link} text={galleryObj3.text} />

                  </div>*/
      }
    } else {
      galleryHTML = (
        <div className="row more-info-row">
          <ImgAndText
            img={galleryObj1.img}
            cssClass={" col-33"}
            link={galleryObj1.link}
            text={galleryObj1.text}
          />
          <ImgAndText
            img={galleryObj2.img}
            cssClass={" col-33"}
            link={galleryObj2.link}
            text={galleryObj2.text}
          />
          <ImgAndText
            img={galleryObj3.img}
            cssClass={" col-33"}
            link={galleryObj3.link}
            text={galleryObj3.text}
          />
          <ImgAndText
            img={galleryObj4.img}
            cssClass={" col-33"}
            link={galleryObj4.link}
            text={galleryObj4.text}
          />
        </div>
      );
    }

    var instagramData = this.state.instagramData;
    // console.log('instagramData: ' , instagramData);

    var insta_size = 2;
    // if ( this.state.width < 1000 ) {
    //     size = 4;
    // }
    if (this.state.width < 600) {
      insta_size = 4;
    }
    if (instagramData.length > 0) {
      while (instagramData.length > 0) {
        this.state.instagramDataMobile.push(
          instagramData.splice(0, insta_size)
        );
      }
    }

    if (this.state.instagramDataMobile.length > 0) {
      instagramHtml = this.state.instagramDataMobile.map((arr, i) => {
        return arr.map((o, i) => {
          var imgLink = "instagram/" + o.id + ".jpg";

          if (this.state.width < 600) {
            imgLink = "instagram/Mobile/" + o.id + ".jpg";
          }
          return (
            <div
              onClick={() => {
                this.openModal(o.id);
              }}
            >
              {" "}
              <InstagremSliderItem
                title={o.publishBy}
                cssClass={"InstagremSliderItem-" + i}
                img={imgLink}
              />
            </div>
          );
        });
      });
      // console.log('instagramHtml2' , instagramHtml2);
      instagramHtml = instagramHtml.map((o, i) => {
        // console.log(o);
        return <div>{o}</div>;
      });
    }

    const currentInstagramLikeUrl =
      "https://www.instagram.com/p/" + this.state.instagramId + "/";
    const currentInstagramUrl =
      "https://www.instagram.com/" + this.state.instagramUserName + "/";
    const currentInstagramImgUrl =
      "instagram/" + this.state.instagramId + ".jpg";

    let a = (
      <div>
        <HomeSlider
          isHomeSlider={true}
          waterTemp={this.state.waterTemp}
          telAvivWeather={this.state.telAvivWeather}
          jerusalemWeather={this.state.jerusalemWeather}
        />
      </div>
    );
    // if ( this.state.isVidClick === true ){
    //   a = <section className="home-section caruasel-wrapper banners-caruasel-wrapper" id="part-1" >
    //   <ResponsiveYouTubeIframe vidId={"5PAjhoH0NWU"} />
    //   </section>
    // }

    return (
      <div className="page align-center page-home">
        {callToActionHtml}
        <Menu />
        <TravelAlert
          toLink={this.state.coronaVirus}
          click={this.closeAlert}
          placeText1={this.state.text1}
          placeText2={this.state.text2}
          placeText3={this.state.text3}
        />

        {a}

        <div className={"ac-wrapper-arrow-down"}>
          <a href="#video" className="ac-goto-video-section">
            <Img mobileImg={"a-down.png"} />
          </a>
        </div>

        <LazyLoad height={200} once offset={50}>
          <section
            className="home-section home-section-padding weather-section hide-on-mobile"
            id="weather-section"
          >
            <div className="container">
              <HomeTitle>معلومات رائعة</HomeTitle>
              <div className="clear"></div>
              <div className="weather-wrapper">
                <WeatherIcon label={"موعد الطائرة"} temp={"2H50"} />
                <WeatherIcon
                  label={"درجة حرارة الماء"}
                  temp={this.state.waterTemp}
                />
                <WeatherIcon
                  label={"تل-أبيب يافا"}
                  temp={this.state.telAvivWeather}
                />
                <WeatherIcon
                  label={"القدس"}
                  temp={this.state.jerusalemWeather}
                />
                <WeatherIcon
                  label={"البحر الميّت"}
                  temp={this.state.deadSeaWeather}
                />
              </div>
            </div>
          </section>
        </LazyLoad>

        <LazyLoad height={200} once offset={100}>
          <section
            className="home-section home-section-padding weather-section"
            id="eurovision"
          >
            <div className="container">
              <div className="clear"></div>
              {euroVisionVid}
              <div className="video-slider-wrapper">
                <SimpleSlider settings={sliderSettings}>
                  {eurovisionHtml}
                </SimpleSlider>
              </div>

              <div className="clear"></div>
            </div>
          </section>
        </LazyLoad>

        <LazyLoad height={200} once offset={50}>
          <section
            className="home-section home-section-padding weather-section"
            id="video"
          >
            <div className="container">
              <HomeTitle>خطّطوا لرحلتكم</HomeTitle>
              <div className="clear"></div>
              {/* <ResponsiveYouTubeIframe vidId={"NlOJ-i5hJdI"} />*/}
              {isMobile() && this.state.imageState ? (
                <ActivaImg
                  src={"PostCarousel/video_mob/activa-img-explure-israel.jpg"}
                  click={this.playVideo}
                />
              ) : (
                <ResponsiveYouTubeIframe vidId={"o59h9p-177c"} />
              )}

              <div className="more-info-wrapper add-margin-top">
                <div className="row more-info-row">
                  <ImgAndText
                    img={img4Url}
                    cssClass={"first"}
                    link={"/Pages/TouristInfoPage"}
                    text={"معلومات للسوّاح >"}
                  />
                  <ImgAndText
                    img={img2Url}
                    cssClass={"last"}
                    link={"/Pages/thingsToDo"}
                    text={"نشاطات ننصح بها >"}
                  />
                </div>

                <div className="row more-info-row">
                  <ImgAndText
                    img={img1Url}
                    cssClass={"first"}
                    link={"/Pages/whereToGo"}
                    text={"لا تفوّتوا زيارة هذه الأماكن >"}
                  />
                  <ImgAndText
                    img={img3Url}
                    cssClass={"last"}
                    link={"/Pages/Videos"}
                    text={"الفيديوهات >"}
                  />
                </div>

                <div className="clear"></div>
              </div>
            </div>
          </section>
        </LazyLoad>

        <LazyLoad height={200} once offset={100}>
          <section
            className="home-section home-section-padding weather-section"
            id="expore-tel-aviv-and-jerusalem"
          >
            <div className="container">
              <HomeTitle>
                <Link to={"/Pages/thingsToDo"} className="ac-plan-your-trip">
                  نشاطات ننصح بها
                </Link>
              </HomeTitle>

              {isMobile() && this.state.imageState8 ? (
                <ActivaImg
                  src={"PostCarousel/video_mob/activa-img-more-things-todo.jpg"}
                  click={this.playVideo8}
                />
              ) : (
                <ResponsiveYouTubeIframe
                  vidId={this.state.exporeTelAvivAndjerusalemMainVid}
                />
              )}
              {/* {twoCitesOneBreakVid}*/}
              <div className="video-slider-wrapper">
                <SimpleSlider settings={sliderSettings}>
                  {videosHtml}
                </SimpleSlider>
              </div>

              <div className="clear"></div>
            </div>
          </section>
        </LazyLoad>
        <div className="clear"></div>

        <section
          className="home-section home-section-padding weather-section"
          id="jerusalem-posts"
        >
          <div className="container">
            <HomeTitle>
              <Link to={"/Pages/JerusalemPage"} className="ac-jerusalem-posts">
                القدس
              </Link>
            </HomeTitle>
            {/*<div className="hide-on-mobile">
              <ResponsiveYouTubeIframe vidId='nLKWDp5uA-U'  />
            </div>*/}

            {isMobile() && this.state.imageState9 ? (
              <ActivaImg
                src={"PostCarousel/video_mob/activa-img-jerusalem.jpg"}
                click={this.playVideo9}
              />
            ) : (
              <ResponsiveYouTubeIframe vidId={"FvAWuLQEOJw"} />
            )}
            <div className="clear"></div>

            <div className="video-slider-wrapper">
              <SimpleSlider settings={sliderSettings}>
                {jerusalemPostsHtml}
              </SimpleSlider>
            </div>

            <div className="clear"></div>
          </div>
        </section>

        <div className="clear"></div>

        <LazyLoad height={200} once offset={400}>
          <section
            className="home-section home-section-padding weather-section"
            id="telaviv-posts"
          >
            <div className="container">
              <HomeTitle>
                <Link to={"/Pages/TelavivPage"} className="ac-telaviv-posts">
                  تل-أبيب يافا
                </Link>
              </HomeTitle>
              {/*<div className="hide-on-mobile">
              <ResponsiveYouTubeIframe vidId='XDei1Zy_cu4'  />
            </div>*/}
              {isMobile() && this.state.imageState10 ? (
                <ActivaImg
                  src={"PostCarousel/video_mob/activa-img-telaviv.jpg"}
                  click={this.playVideo10}
                />
              ) : (
                <ResponsiveYouTubeIframe vidId={"tgF0zMUYY2g"} />
              )}
              <div className="clear"></div>

              <div className="video-slider-wrapper">
                <SimpleSlider settings={sliderSettings}>
                  {telavivPostsHtml}
                </SimpleSlider>
              </div>

              <div className="clear"></div>
            </div>
          </section>
        </LazyLoad>

        <div className="clear"></div>

        <LazyLoad height={200} once offset={100}>
          <section
            className="home-section home-section-padding weather-section"
            id="CULINARY"
          >
            <div className="container">
              <HomeTitle>
                <Link to={"/Pages/CulinaryPage"} className="ac-coolinary-exp">
                  أفضل الأطباق، أفضل التجارب
                </Link>
              </HomeTitle>
              <div className="clear"></div>
              {/*{culinaryVid}*/}
              {isMobile() && this.state.imageState7 ? (
                <ActivaImg
                  src={"PostCarousel/video_mob/activa-img-culinary.jpg"}
                  click={this.playVideo7}
                />
              ) : (
                <ResponsiveYouTubeIframe vidId={this.state.culinaryVid} />
              )}
              <div className="clear"></div>
              <div className="video-slider-wrapper">
                <SimpleSlider settings={sliderSettings}>
                  {culinaryHtml}
                </SimpleSlider>
              </div>

              <div className="clear"></div>
            </div>
          </section>
        </LazyLoad>

        <div className="clear"></div>

        <LazyLoad height={200} once offset={400}>
          <section
            className="home-section home-section-padding weather-section"
            id="deadsea-posts"
          >
            <div className="container">
              <HomeTitle>
                <Link to={"/Pages/DeadSeaPage"} className="ac-dead-posts">
                  البحر الميت
                </Link>
              </HomeTitle>
              {/*<div className="hide-on-mobile">
              <ResponsiveYouTubeIframe vidId='ixFocykfYHo'  />
            </div>*/}
              {isMobile() && this.state.imageState2 ? (
                <ActivaImg
                  src={"PostCarousel/video_mob/activa-img-deadsea.jpg"}
                  click={this.playVideo2}
                />
              ) : (
                <ResponsiveYouTubeIframe vidId={"M627s8TdaB8"} />
              )}
              <div className="clear"></div>

              <div className="video-slider-wrapper">
                <SimpleSlider settings={sliderSettings}>
                  {/* {DeadSeaHtml}*/}
                  {deadseaPostsHtml}
                </SimpleSlider>
              </div>

              <div className="clear"></div>
            </div>
          </section>
        </LazyLoad>

        <div className="clear"></div>

        <LazyLoad height={200} once offset={400}>
          <section
            className="home-section home-section-padding weather-section"
            id="eilat-negev-posts"
          >
            <div className="container">
              <HomeTitle>
                <Link
                  to={"/Pages/EilatNegevPage"}
                  className="ac-eilat-negev-posts"
                >
                  زوروا النقب وإيلات
                </Link>
              </HomeTitle>
              {/*<div className="hide-on-mobile">
              <ResponsiveYouTubeIframe vidId='ZdnNT-GDJv4'  />
            </div>*/}
              {isMobile() && this.state.imageState3 ? (
                <ActivaImg
                  src={"PostCarousel/video_mob/activa-img-negev-eilat.jpg"}
                  click={this.playVideo3}
                />
              ) : (
                <ResponsiveYouTubeIframe vidId={"i_4QKtXIeto"} />
              )}
              <div className="clear"></div>

              <div className="video-slider-wrapper">
                <SimpleSlider settings={sliderSettings}>
                  {eilatNegevPostsHtml}
                </SimpleSlider>
              </div>

              <div className="clear"></div>
            </div>
          </section>
        </LazyLoad>

        <LazyLoad height={200} once offset={400}>
          <section
            className="home-section home-section-padding weather-section"
            id="north"
          >
            <div className="container">
              <HomeTitle>
                <Link to={"/Pages/NorthPage"} className="ac-north-posts">
                  زوروا منطقة الجليل
                </Link>
              </HomeTitle>
              {/* <div className="hide-on-mobile">
              <ResponsiveYouTubeIframe vidId='lzYzxyvnfng'  />
            </div>*/}
              {isMobile() && this.state.imageState4 ? (
                <ActivaImg
                  src={"PostCarousel/video_mob/activa-img-north.jpg"}
                  click={this.playVideo4}
                />
              ) : (
                <ResponsiveYouTubeIframe vidId={"lzYzxyvnfng"} />
              )}
              <div className="clear"></div>

              <div className="video-slider-wrapper">
                <SimpleSlider settings={sliderSettings2}>
                  {northPostsHtml}
                </SimpleSlider>
              </div>

              <div className="clear"></div>
            </div>
          </section>
        </LazyLoad>

        <LazyLoad height={200} once offset={400}>
          <section
            className="home-section home-section-padding weather-section"
            id="instagram"
          >
            <div className="container">
              <HomeTitle>
                الصور التي قمتم <br className={"ac-show-on-mobile"} />
                بالتقاطها في إسرائيل
              </HomeTitle>

              {isMobile() && this.state.imageState5 ? (
                <ActivaImg
                  src={"PostCarousel/video_mob/activa-img-insta.jpg"}
                  click={this.playVideo5}
                />
              ) : (
                <ResponsiveYouTubeIframe vidId={"z0OoUqKkwwM"} />
              )}
              <p className="ac-credit-home">
                <small>الحقوق لـ :فابيو ويبمر</small>
              </p>
              <div className="clear"></div>

              <div className="video-slider-wrapper">
                <SimpleSlider settings={sliderSettings}>
                  {instagramHtml}
                </SimpleSlider>
              </div>

              <div className="clear"></div>
            </div>
          </section>
        </LazyLoad>

        {/*<LazyLoad height={200} once offset={400}>
               <section className="home-section home-section-padding weather-section" id="shows">
                 <div className="container">
                   <HomeTitle>
                     <Link to={'/Pages/liveShows'} className="ac-shows">عروض واحتفالات دولية حية </Link>          
                   </HomeTitle>
                   <div className="clear"></div>
                   
                   <div className="video-slider-wrapper">
                     <SimpleSlider settings={sliderSettings}>
                       {concertSHtml}
                     </SimpleSlider>
                   </div>
       
                   <div className="clear"></div>
                 </div>
               </section>
               </LazyLoad> */}

        <LazyLoad height={200} once offset={400}>
          <section
            className="home-section home-section-padding weather-section"
            id="gallery"
          >
            <div className="container">
              <HomeTitle>
                <Link to={"/Pages/Gallery/"} className="ac-gallery-home-page">
                  معرض الصور
                </Link>
              </HomeTitle>
              <div className="clear"></div>

              {galleryHTML}

              <div className="clear"></div>
            </div>
          </section>
        </LazyLoad>

        <LazyLoad height={200} once offset={400}>
          <section className="home-section home-section-padding " id="faq">
            <div className="container">
              <HomeTitle>
                <Link to={"/Pages/FAQ"} className="ac-faq">
                  أسئلة شائعة
                </Link>
              </HomeTitle>
              <div className="clear"></div>

              <div className="faq-wrapper">{faqHtml}</div>
              <div className="clear"></div>
            </div>
          </section>
        </LazyLoad>

        <LazyLoad height={200} once offset={400}>
          <Footer />
        </LazyLoad>

        <Popup
          open={this.state.open}
          closeOnDocumentClick
          onClose={this.closeModal}
        >
          <div className="modal">
            <a className="close" onClick={this.closeModal}>
              &times;
            </a>
            <div className="userImgInstagram">
              <Img desktopImg={currentInstagramImgUrl} />
            </div>
            <div className="user-info-instagram">
              <a target="_blank" href={currentInstagramUrl}>
                <div className="userProfileImgWrapper">
                  <img src={this.state.instagramUserImg} />
                </div>
                @{this.state.instagramUserName}
              </a>

              <div className="instagramCaption">
                <p>
                  {this.state.instagramCaption != null
                    ? limitText(this.state.instagramCaption, 130)
                    : ""}
                </p>
              </div>
            </div>

            <div className="clear"></div>
            <a target="_blank" href={currentInstagramLikeUrl}>
              <div className="like-wrapper">
                <Img desktopImg={"like.png"} />
              </div>
            </a>
          </div>
        </Popup>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Pages/Home/Home.js